import { z } from "zod";

import { env } from "@/common/env/client.mjs";

type Queries = z.infer<typeof queriesSchema>;

const queriesSchema = z.object({
  city: z.string().optional(),
  product: z.string().optional(),
});

const getCatalogPageUrl = (queries?: Queries) => {
  const result = queriesSchema.nullish().parse(queries);
  const parsedQueries = Object.entries(result ?? [])
    .map(([key, value]) => `${key}=${value}`)
    .join("&");
  const final = parsedQueries.length > 0 ? `?${parsedQueries}` : "";

  return `${env.NEXT_PUBLIC_BASE_URL}/katalog-badan${final}`;
};

export const goToCatalogPage = (queries?: Queries) => {
  window.location.assign(getCatalogPageUrl(queries));
};
